import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetAddressRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetAddressResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setAddress = (request: SetAddressRequest, options?: CashRequestOptions) =>
  post<SetAddressRequest, SetAddressResponse>('/2.0/cash/set-address', request, { ...options, rejectOnError: true })
